import { useState, useEffect } from 'react';

export const useDarkMode = () => {
  // Inicijalizacija: provjeri localStorage ili sistemske postavke
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem('theme-mode') === 'dark' || 
           (!localStorage.getItem('theme-mode') && window.matchMedia('(prefers-color-scheme: dark)').matches);
  });

  useEffect(() => {
    const root = window.document.documentElement; // Dohvati <html> tag
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme-mode', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme-mode', 'light');
    }
  }, [isDark]);

  return [isDark, setIsDark];
};